export function VirtualNode(tag = '', props = new VirtualProps(), children = []) {
  this.tag = tag;
  this.props = props;
  this.children = children;
}

VirtualNode.prototype.addChild = function () {
  if (!this.children) {
    this.children = [];
  }

  this.children.push(this.children);
};

export function VirtualProps(name = '', platform = '', style = {}, action = {}, attrs = {}) {
  this.name = name;
  this.platform = platform;
  this.style = style;
  this.action = action;
  this.attrs = attrs;
}
